<template>
  <div class="collection-gate-opening">
    <h2 class="collection-gate-opening__heading">
      The Erotic City collection is launching soon
    </h2>
    <p class="collection-gate-opening__text">
      Log in to check your access level.
    </p>
    <div class="collection-gate-opening__button">
      <Button type="button" theme="primary-light" @click="$emit('login')">
        SIGN IN
      </Button>
    </div>
  </div>
</template>

<script>
import { getFeatureToggles } from "@/helpers/featureToggles.js";
import { format } from "date-fns";
import Button from "@/components/ButtonV3.vue";

export default {
  name: "CollectionGateOpening",
  components: {
    Button,
  },
  emits: ["login", "register"],
  computed: {
    formattedLevel2Date() {
      const { collectionGateAccessTime = "2025-03-28T11:00:00Z" } =
        getFeatureToggles();
      const date = new Date(collectionGateAccessTime);
      return format(date, "do MMMM yyyy 'at' h:mm a 'GMT'");
    },
    formattedLevel1Date() {
      const { collectionGateLevel1AccessTime = "2025-03-28T12:00:00Z" } =
        getFeatureToggles();
      const date = new Date(collectionGateLevel1AccessTime);
      return format(date, "do MMMM yyyy 'at' h:mm a 'GMT'");
    },
  },
};
</script>

<style lang="scss" scoped>
.collection-gate-opening {
  text-align: center;
  color: $color-white;
  padding: 20px;

  @include respond-above(md) {
    color: $color-white;
    padding: 40px;
  }
}

.collection-gate-opening__heading {
  @include editorial-headline(24px);
  line-height: 1.2;
  margin-bottom: 24px;
  color: $color-white;
  text-transform: uppercase;

  @include respond-above(md) {
    @include editorial-headline(32px);
    color: $color-white;
    margin-bottom: 32px;
  }
}

.collection-gate-opening__text {
  @include editorial-body(16px);
  margin-bottom: 32px;
  color: $color-white;
  max-width: 400px;
  margin-left: auto;
  margin-right: auto;
  line-height: 1.6;

  br {
    content: "";
    display: block;
    margin: 12px 0;
  }

  @include respond-above(md) {
    @include editorial-body(18px);
    margin-bottom: 48px;
    color: $color-white;

    br {
      margin: 16px 0;
    }
  }
}

.collection-gate-opening__button {
  display: flex;
  justify-content: center;
  max-width: 280px;
  margin: 0 auto;

  :deep(.button) {
    width: 100%;
  }

  @include respond-above(md) {
    max-width: 320px;
  }
}
</style>
